module.exports = {
  AGING_CODE: 'aging_code_default',
  CURRENCY: 'currency_default',
  CUT_ID: 'cut_id_default',
  MATCH_ID: 'match_id',
  ORG_JOB_ID: 'org_job_id_default',
  ORG_JOB_CODE: 'org_job_code_default',
  ORG_JOB_CODE_KEY: 'org_job_code_key_default',
  ORG_JOB_DESCRIPTION: 'org_job_description_default'
};
